import { Theme } from '@ui/types'
import { ButtonVariantsDefined } from '@ui/buttons/Button/types'
import { colors as c } from '@ui/colors'

type ButtonThemeVariant<T> = Record<Theme, Record<ButtonVariantsDefined, T>>

export const buttonThemeBack: ButtonThemeVariant<[string, string]> = {
  light: {
    filled: [c.black25, c.black50],
    outlined: [c.text0, c.text10],
  },
  dark: {
    filled: [c.white25, c.white50],
    outlined: [c.white0, c.white25],
  },
}

export const buttonThemeFront: ButtonThemeVariant<string> = {
  light: {
    filled: c.white,
    outlined: c.black,
  },
  dark: {
    filled: c.white,
    outlined: c.white,
  },
}

export const buttonThemeBorder: ButtonThemeVariant<[string, string]> = {
  light: {
    filled: [c.black0, c.black0],
    outlined: [c.text25, c.text50],
  },
  dark: {
    filled: [c.white0, c.white0],
    outlined: [c.white25, c.white],
  },
}
